const defaultFilter = {
  label: 'Autres filtres',
  value: 'Autres',
}

export default defaultFilter
